export default {
    "en": {
        "(and {count} more error)": "(and {count} more error)",
        "(and {count} more errors)": "(and {count} more error)|(and {count} more errors)|(and {count} more errors)",
        "404 - Page not found": "404 - Page not found",
        "8-12 hours": "8-12 hours",
        "{Attribute} {lang}": "{Attribute} {lang}",
        "{count} characters": "{count} characters",
        "A decryption key is required.": "A decryption key is required.",
        "A Timeout Occurred": "A Timeout Occurred",
        "About store text": "About store text",
        "About store title": "About store title",
        "About us": "About us",
        "Accept": "Accept",
        "Accepted": "Accepted",
        "Action": "Action",
        "Actions": "Actions",
        "Active": "Active",
        "Active promotion": "Active promotion",
        "Add": "Add",
        "Add {name}": "Add {name}",
        "Address & contact": "Address & contact",
        "Admin": "Admin",
        "Administrator": "Administrator",
        "Agree": "Agree",
        "All rights reserved.": "All rights reserved.",
        "All vacancies": "All vacancies",
        "Already Reported": "Already Reported",
        "Apply directly": "Apply directly",
        "Apply now": "Apply now",
        "Archive": "Archive",
        "Assign": "Assign",
        "Associate": "Associate",
        "at Jumbo Bas Bobeldijk": "at Jumbo Bas Bobeldijk",
        "Attach": "Attach",
        "Available in:": "Available in:",
        "Back to home": "Back to home",
        "Bad Gateway": "Bad Gateway",
        "Bad Request": "Bad Request",
        "Bandwidth Limit Exceeded": "Bandwidth Limit Exceeded",
        "Banner": "Banner",
        "Birthday *": "Birthday *",
        "Browse": "Browse",
        "Cancel": "Cancel",
        "Choose": "Choose",
        "Choose {name}": "Choose {name}",
        "Choose file": "Choose file",
        "Choose File": "Choose File",
        "Choose Image": "Choose Image",
        "City": "City",
        "Click to copy": "Click to copy",
        "Client Closed Request": "Client Closed Request",
        "Close": "Close",
        "Collapse": "Collapse",
        "Collapse All": "Collapse All",
        "Comment": "Comment",
        "Company name": "Company name",
        "Confirm": "Confirm",
        "Conflict": "Conflict",
        "Connect": "Connect",
        "Connection Closed Without Response": "Connection Closed Without Response",
        "Connection Timed Out": "Connection Timed Out",
        "Contact": "Contact",
        "Contact Cards": "Contact Cards",
        "Content": "Content",
        "Content Detail Page": "Content Detail Page",
        "Content Repeater": "Content Repeater",
        "Continue": "Continue",
        "Create": "Create",
        "Create {name}": "Create {name}",
        "Created": "Created",
        "Cta": "Cta",
        "Current Actions": "Current Actions",
        "Delete": "Delete",
        "Delete {name}": "Delete {name}",
        "Delete filters": "Delete filters",
        "Description": "Description",
        "description": "description",
        "Detach": "Detach",
        "Details": "Details",
        "Different opening hours": "Different opening hours",
        "Different openings hours": "Different openings hours",
        "Different openingshours": "Different openingshours",
        "Disable": "Disable",
        "Discard": "Discard",
        "Discount": "Discount",
        "Discount active": "Discount active",
        "Done": "Done",
        "Down": "Down",
        "Duplicate": "Duplicate",
        "Duplicate {name}": "Duplicate {name}",
        "E-mail": "E-mail",
        "E-mail *": "E-mail *",
        "Edit": "Edit",
        "Edit {name}": "Edit {name}",
        "Email": "Email",
        "Enable": "Enable",
        "Encrypted environment file already exists.": "Encrypted environment file already exists.",
        "Encrypted environment file not found.": "Encrypted environment file not found.",
        "End": "End",
        "Enter working hours here": "Enter working hours here",
        "Environment file already exists.": "Environment file already exists.",
        "Environment file not found.": "Environment file not found.",
        "errors": "errors",
        "Everything for the nicest shopping": "Everything for the nicest shopping",
        "Excerpt": "Excerpt",
        "excerpt": "excerpt",
        "Expand": "Expand",
        "Expand All": "Expand All",
        "Expectation Failed": "Expectation Failed",
        "Explanation": "Explanation",
        "Export": "Export",
        "Export {name}": "Export {name}",
        "external url": "external url",
        "Facebook URL": "Facebook URL",
        "Failed Dependency": "Failed Dependency",
        "File": "File",
        "Files": "Files",
        "Fine workplace": "Fine workplace",
        "First name *": "First name *",
        "Forbidden": "Forbidden",
        "Form": "Form",
        "Form Job Application": "Form Job Application",
        "Found": "Found",
        "Gateway Timeout": "Gateway Timeout",
        "Go Home": "Go Home",
        "Go to page {page}": "Go to page {page}",
        "Gone": "Gone",
        "Google Maps URL": "Google Maps URL",
        "Google maps URL": "Google maps URL",
        "Hello": "Hello",
        "Hello!": "Hello!",
        "Heroes": "Heroes",
        "Hide": "Hide",
        "Hide {name}": "Hide {name}",
        "Hits": "Hits",
        "Home": "Home",
        "Hours": "Hours",
        "hours": "hours",
        "HTTP Version Not Supported": "HTTP Version Not Supported",
        "I'm a teapot": "I'm a teapot",
        "If enabled, and no image is uploaded, the banner from the homepage will be shown.": "If enabled, and no image is uploaded, the banner from the homepage will be shown.",
        "If url filled in, link will be opend in a new tab. Leave empty if using Sub items": "If url filled in, link will be opend in a new tab. Leave empty if using Sub items",
        "If you did not create an account, no further action is required.": "If you did not create an account, no further action is required.",
        "If you did not request a password reset, no further action is required.": "If you did not request a password reset, no further action is required.",
        "If you're having trouble clicking the \"{actionText}\" button, copy and paste the URL below\ninto your web browser:": "If you're having trouble clicking the \"{actionText}\" button, copy and paste the URL below\ninto your web browser:",
        "If you're having trouble clicking the \"{actionText}\" button, copy and paste the URL belowninto your web browser:": "If you're having trouble clicking the \"{actionText}\" button, copy and paste the URL belowninto your web browser:",
        "IM Used": "IM Used",
        "Image": "Image",
        "image-left": "image-left",
        "image-right": "image-right",
        "Impersonate": "Impersonate",
        "Impersonation": "Impersonation",
        "Import": "Import",
        "Import {name}": "Import {name}",
        "Index Page": "Index Page",
        "Instagram URL": "Instagram URL",
        "Insufficient Storage": "Insufficient Storage",
        "Internal Server Error": "Internal Server Error",
        "Intro Block": "Intro Block",
        "Introduction": "Introduction",
        "Invalid filename.": "Invalid filename.",
        "Invalid JSON was returned from the route.": "Invalid JSON was returned from the route.",
        "Invalid SSL Certificate": "Invalid SSL Certificate",
        "It is recommended to keep the {attribute} between {min} and {max} characters long": "It is recommended to keep the {attribute} between {min} and {max} characters long",
        "Last name *": "Last name *",
        "Leave empty for no end date": "Leave empty for no end date",
        "Leave empty to use parent details": "Leave empty to use parent details",
        "length": "length",
        "Length Required": "Length Required",
        "Like": "Like",
        "LinkedIn URL": "LinkedIn URL",
        "Load": "Load",
        "Local assortment": "Local assortment",
        "Local heroes": "local heroes",
        "local heroes": "local heroes",
        "Localize": "Localize",
        "Location": "Location",
        "Locked": "Locked",
        "Log In": "Log In",
        "Log Out": "Log Out",
        "Login": "Login",
        "Logout": "Logout",
        "Loop Detected": "Loop Detected",
        "Made by:": "Made by:",
        "Maintenance Mode": "Maintenance Mode",
        "marker icon": "marker icon",
        "Method Not Allowed": "Method Not Allowed",
        "Misdirected Request": "Misdirected Request",
        "Motivation *": "Motivation *",
        "Moved Permanently": "Moved Permanently",
        "Multi-Status": "Multi-Status",
        "Multiple Choices": "Multiple Choices",
        "Name": "name",
        "name": "name",
        "Name *": "Name *",
        "Network Authentication Required": "Network Authentication Required",
        "Network Connect Timeout Error": "Network Connect Timeout Error",
        "Network Read Timeout Error": "Network Read Timeout Error",
        "New": "New",
        "New {name}": "New {name}",
        "New URL": "New URL",
        "News overview": "News overview",
        "No": "No",
        "No Content": "No Content",
        "Non-Authoritative Information": "Non-Authoritative Information",
        "Not Acceptable": "Not Acceptable",
        "Not Extended": "Not Extended",
        "Not Found": "Not Found",
        "Not Implemented": "Not Implemented",
        "Not Modified": "Not Modified",
        "Now in our stores": "Now in our stores",
        "of": "of",
        "OK": "OK",
        "Old URL": "Old URL",
        "Open": "Open",
        "Open in a current window": "Open in a current window",
        "Open in a new window": "Open in a new window",
        "Open in a parent frame": "Open in a parent frame",
        "Open in the topmost frame": "Open in the topmost frame",
        "Open on the website": "Open on the website",
        "Openings hours": "Openings hours",
        "Openingshours": "Openingshours",
        "Order": "Order",
        "Origin Is Unreachable": "Origin Is Unreachable",
        "Other local heroes": "Other local heroes",
        "Our": "Our",
        "Our Stores": "Our Stores",
        "Page Expired": "Page Expired",
        "Pagination Navigation": "Pagination Navigation",
        "Parent category": "Parent category",
        "Partial Content": "Partial Content",
        "Payload Too Large": "Payload Too Large",
        "Payment Required": "Payment Required",
        "Permanent": "Permanent",
        "Permanent Redirect": "Permanent Redirect",
        "Phone": "Phone",
        "Phone *": "Phone *",
        "Place": "Place",
        "Please click the button below to verify your email address.": "Please click the button below to verify your email address.",
        "Postal code": "Postal code",
        "Precondition Failed": "Precondition Failed",
        "Precondition Required": "Precondition Required",
        "Preview": "Preview",
        "Price": "Price",
        "Privacy declaration": "Privacy declaration",
        "Processing": "Processing",
        "Promotion image, will be show if article is visible on homepage, image placed on the right side of the card.": "Promotion image, will be show if article is visible on homepage, image placed on the right side of the card.",
        "Proxy Authentication Required": "Proxy Authentication Required",
        "Railgun Error": "Railgun Error",
        "Range Not Satisfiable": "Range Not Satisfiable",
        "Record": "Record",
        "Regards": "Regards",
        "Regards,": "Regards,",
        "Register": "Register",
        "Request Header Fields Too Large": "Request Header Fields Too Large",
        "Request Timeout": "Request Timeout",
        "Reset Content": "Reset Content",
        "Reset Password": "Reset Password",
        "Reset Password Notification": "Reset Password Notification",
        "Reset your password": "Reset your password",
        "Restore": "Restore",
        "Restore {name}": "Restore {name}",
        "results": "results",
        "Retry With": "Retry With",
        "Sales": "Sales",
        "Save": "Save",
        "Save & Close": "Save & Close",
        "Save & Return": "Save & Return",
        "Save {name}": "Save {name}",
        "Search": "Search",
        "Search {name}": "Search {name}",
        "See all heroes": "See all heroes",
        "See all news": "See all news",
        "See Other": "See Other",
        "Select": "Select",
        "Select All": "Select All",
        "Send": "Send",
        "Send application": "Send application",
        "Send email": "Send email",
        "SEO title": "SEO title",
        "Server Error": "Server Error",
        "Service Unavailable": "Service Unavailable",
        "Services": "Services",
        "Session Has Expired": "Session Has Expired",
        "Settings": "Settings",
        "Show": "Show",
        "Show {name}": "Show {name}",
        "Show All": "Show All",
        "Show this article on the homepage as current promotion": "Show this article on the homepage as current promotion",
        "Showing": "Showing",
        "Sign In": "Sign In",
        "Slug": "Slug",
        "Social media": "Social media",
        "Solve": "Solve",
        "Special Openings hours": "Special Openings hours",
        "SSL Handshake Failed": "SSL Handshake Failed",
        "Start": "Start",
        "Stay tuned for fun news, giveaways, offers and more!": "Stay tuned for fun news, giveaways, offers and more!",
        "Stop": "Stop",
        "Store detail overview": "Store detail overview",
        "Store image": "Store image",
        "Store name": "Store name",
        "Stores Compact": "Stores Compact",
        "Street": "Street",
        "Street name": "Street name",
        "Submit": "Submit",
        "Subscribe": "Subscribe",
        "Switch": "Switch",
        "Switch To Role": "Switch To Role",
        "Switching Protocols": "Switching Protocols",
        "Tag": "Tag",
        "Tags": "Tags",
        "Temporary Redirect": "Temporary Redirect",
        "Terms and Conditions": "Terms and Conditions",
        "Text": "Text",
        "text": "text",
        "Text left, image right": "Text left, image right",
        "Text right, image left": "Text right, image left",
        "Thank you for your application!": "Thank you for your application!",
        "The {attribute} must contain at least one letter.": "The {attribute} must contain at least one letter.",
        "The {attribute} must contain at least one number.": "The {attribute} must contain at least one number.",
        "The {attribute} must contain at least one symbol.": "The {attribute} must contain at least one symbol.",
        "The {attribute} must contain at least one uppercase and one lowercase letter.": "The {attribute} must contain at least one uppercase and one lowercase letter.",
        "The given {attribute} has appeared in a data leak. Please choose a different {attribute}.": "The given {attribute} has appeared in a data leak. Please choose a different {attribute}.",
        "The given data was invalid.": "The given data was invalid.",
        "The response is not a streamed response.": "The response is not a streamed response.",
        "The response is not a view.": "The response is not a view.",
        "This action is unauthorized.": "This action is unauthorized.",
        "This page does not exist": "This page does not exist",
        "This password reset link will expire in {count} minutes.": "This password reset link will expire in {count} minutes.",
        "Title": "Title",
        "title": "title",
        "Title different opening hours": "Title different opening hours",
        "Title Special Openings hours": "Title Special Openings hours",
        "to": "to",
        "Toggle navigation": "Toggle navigation",
        "Too Early": "Too Early",
        "Too Many Requests": "Too Many Requests",
        "Translate": "Translate",
        "Translate It": "Translate It",
        "Type": "Type",
        "Unauthorized": "Unauthorized",
        "Unavailable For Legal Reasons": "Unavailable For Legal Reasons",
        "Unknown Error": "Unknown Error",
        "Unpack": "Unpack",
        "Unprocessable Entity": "Unprocessable Entity",
        "Unsubscribe": "Unsubscribe",
        "Unsupported Media Type": "Unsupported Media Type",
        "Up": "Up",
        "Update": "Update",
        "Update {name}": "Update {name}",
        "Upgrade Required": "Upgrade Required",
        "Upload C.V": "Upload C.V",
        "Upload C.V *": "Upload C.V *",
        "Upload Motivation": "Upload Motivation",
        "Upload Motivation *": "Upload Motivation *",
        "URI Too Long": "URI Too Long",
        "url": "url",
        "Use Proxy": "Use Proxy",
        "User": "User",
        "Users": "Users",
        "Vacancies": "Vacancies",
        "vacancies": "vacancies",
        "Vacancies Recent": "Vacancies Recent",
        "vacancy": "vacancy",
        "Vacancy Overview": "Vacancy Overview",
        "Vacancyfilters": "Vacancyfilters",
        "Variant Also Negotiates": "Variant Also Negotiates",
        "Variants": "Variants",
        "Verify Email Address": "Verify Email Address",
        "Verify your email address": "Verify your email address",
        "View": "View",
        "View {name}": "View {name}",
        "We have done our best, but it seems that the page you requested does not exist (anymore) or that it may have moved.": "We have done our best, but it seems that the page you requested does not exist (anymore) or that it may have moved.",
        "We have done our best, but it seems that the page you requested does not exist (anymore) or that it may have moved. Of course you can always go to the homepage, one of our departments or view one of our projects, for example.": "We have done our best, but it seems that the page you requested does not exist (anymore) or that it may have moved. Of course you can always go to the homepage, one of our departments or view one of our projects, for example.",
        "Web Page": "Web Page",
        "Web Server is Down": "Web Server is Down",
        "Webshop vers bereide producten": "Webshop vers bereide producten",
        "Website": "Website",
        "What kind of work are you looking for?": "What kind of work are you looking for?",
        "When enabled, an email will be sent to the user, letting them know their account has been created.": "When enabled, an email will be sent to the user, letting them know their account has been created.",
        "Which store do you want to work at?": "Which store do you want to work at?",
        "Whoops!": "Whoops!",
        "Yes": "Yes",
        "You are receiving this email because we received a password reset request for your account.": "You are receiving this email because we received a password reset request for your account.",
        "Your account for {siteName}": "Your account for {siteName}",
        "Your message has been sent successfully!": "Your message has been sent successfully!",
        "auth": {
            "failed": "These credentials do not match our records.",
            "password": "The provided password is incorrect.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds."
        },
        "actions": {
            "accept": "Accept",
            "action": "Action",
            "actions": "Actions",
            "add": "Add",
            "admin": "Admin",
            "agree": "Agree",
            "archive": "Archive",
            "assign": "Assign",
            "associate": "Associate",
            "attach": "Attach",
            "browse": "Browse",
            "cancel": "Cancel",
            "choose": "Choose",
            "choose_file": "Choose File",
            "choose_image": "Choose Image",
            "click_to_copy": "Click to copy",
            "close": "Close",
            "collapse": "Collapse",
            "collapse_all": "Collapse All",
            "comment": "Comment",
            "confirm": "Confirm",
            "connect": "Connect",
            "create": "Create",
            "delete": "Delete",
            "detach": "Detach",
            "details": "Details",
            "disable": "Disable",
            "discard": "Discard",
            "done": "Done",
            "down": "Down",
            "duplicate": "Duplicate",
            "edit": "Edit",
            "enable": "Enable",
            "expand": "Expand",
            "expand_all": "Expand All",
            "explanation": "Explanation",
            "export": "Export",
            "file": "File",
            "files": "Files",
            "go_home": "Go Home",
            "hide": "Hide",
            "home": "Home",
            "image": "Image",
            "impersonate": "Impersonate",
            "impersonation": "Impersonation",
            "import": "Import",
            "introduction": "Introduction",
            "like": "Like",
            "load": "Load",
            "localize": "Localize",
            "log_in": "Log In",
            "log_out": "Log Out",
            "named": {
                "add": "Add {name}",
                "choose": "Choose {name}",
                "create": "Create {name}",
                "delete": "Delete {name}",
                "duplicate": "Duplicate {name}",
                "edit": "Edit {name}",
                "export": "Export {name}",
                "hide": "Hide {name}",
                "import": "Import {name}",
                "new": "New {name}",
                "restore": "Restore {name}",
                "save": "Save {name}",
                "search": "Search {name}",
                "show": "Show {name}",
                "update": "Update {name}",
                "view": "View {name}"
            },
            "new": "New",
            "no": "No",
            "open": "Open",
            "open_website": "Open on the website",
            "preview": "Preview",
            "price": "Price",
            "record": "Record",
            "restore": "Restore",
            "save": "Save",
            "save_and_close": "Save & Close",
            "save_and_return": "Save & Return",
            "search": "Search",
            "select": "Select",
            "select_all": "Select All",
            "send": "Send",
            "settings": "Settings",
            "show": "Show",
            "show_all": "Show All",
            "sign_in": "Sign In",
            "solve": "Solve",
            "start": "Start",
            "stop": "Stop",
            "submit": "Submit",
            "subscribe": "Subscribe",
            "switch": "Switch",
            "switch_to_role": "Switch To Role",
            "tag": "Tag",
            "tags": "Tags",
            "target_link": {
                "blank": "Open in a new window",
                "parent": "Open in a parent frame",
                "self": "Open in a current window",
                "top": "Open in the topmost frame"
            },
            "translate": "Translate",
            "translate_it": "Translate It",
            "unpack": "Unpack",
            "unsubscribe": "Unsubscribe",
            "up": "Up",
            "update": "Update",
            "user": "User",
            "view": "View",
            "yes": "Yes"
        },
        "validation": {
            "accepted": "The {attribute} field must be accepted.",
            "accepted_if": "The {attribute} field must be accepted when {other} is {value}.",
            "active_url": "The {attribute} field must be a valid URL.",
            "after": "The {attribute} field must be a date after {date}.",
            "after_or_equal": "The {attribute} field must be a date after or equal to {date}.",
            "alpha": "The {attribute} field must only contain letters.",
            "alpha_dash": "The {attribute} field must only contain letters, numbers, dashes, and underscores.",
            "alpha_num": "The {attribute} field must only contain letters and numbers.",
            "any_of": "The {attribute} field is invalid.",
            "array": "The {attribute} field must be an array.",
            "ascii": "The {attribute} field must only contain single-byte alphanumeric characters and symbols.",
            "before": "The {attribute} field must be a date before {date}.",
            "before_or_equal": "The {attribute} field must be a date before or equal to {date}.",
            "between": {
                "array": "The {attribute} field must have between {min} and {max} items.",
                "file": "The {attribute} field must be between {min} and {max} kilobytes.",
                "numeric": "The {attribute} field must be between {min} and {max}.",
                "string": "The {attribute} field must be between {min} and {max} characters."
            },
            "boolean": "The {attribute} field must be true or false.",
            "can": "The {attribute} field contains an unauthorized value.",
            "confirmed": "The {attribute} field confirmation does not match.",
            "contains": "The {attribute} field is missing a required value.",
            "current_password": "The password is incorrect.",
            "date": "The {attribute} field must be a valid date.",
            "date_equals": "The {attribute} field must be a date equal to {date}.",
            "date_format": "The {attribute} field must match the format {format}.",
            "decimal": "The {attribute} field must have {decimal} decimal places.",
            "declined": "The {attribute} field must be declined.",
            "declined_if": "The {attribute} field must be declined when {other} is {value}.",
            "different": "The {attribute} field and {other} must be different.",
            "digits": "The {attribute} field must be {digits} digits.",
            "digits_between": "The {attribute} field must be between {min} and {max} digits.",
            "dimensions": "The {attribute} field has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "doesnt_contain": "The {attribute} field must not contain any of the following: {values}.",
            "doesnt_end_with": "The {attribute} field must not end with one of the following: {values}.",
            "doesnt_start_with": "The {attribute} field must not start with one of the following: {values}.",
            "email": "The {attribute} field must be a valid email address.",
            "encoding": "The {attribute} field must be encoded in {encoding}.",
            "ends_with": "The {attribute} field must end with one of the following: {values}.",
            "enum": "The selected {attribute} is invalid.",
            "exists": "The selected {attribute} is invalid.",
            "extensions": "The {attribute} field must have one of the following extensions: {values}.",
            "file": "The {attribute} field must be a file.",
            "filled": "The {attribute} field must have a value.",
            "gt": {
                "array": "The {attribute} field must have more than {value} items.",
                "file": "The {attribute} field must be greater than {value} kilobytes.",
                "numeric": "The {attribute} field must be greater than {value}.",
                "string": "The {attribute} field must be greater than {value} characters."
            },
            "gte": {
                "array": "The {attribute} field must have {value} items or more.",
                "file": "The {attribute} field must be greater than or equal to {value} kilobytes.",
                "numeric": "The {attribute} field must be greater than or equal to {value}.",
                "string": "The {attribute} field must be greater than or equal to {value} characters."
            },
            "hex_color": "The {attribute} field must be a valid hexadecimal color.",
            "image": "The {attribute} field must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field must exist in {other}.",
            "in_array_keys": "The {attribute} field must contain at least one of the following keys: {values}.",
            "integer": "The {attribute} field must be an integer.",
            "ip": "The {attribute} field must be a valid IP address.",
            "ipv4": "The {attribute} field must be a valid IPv4 address.",
            "ipv6": "The {attribute} field must be a valid IPv6 address.",
            "json": "The {attribute} field must be a valid JSON string.",
            "list": "The {attribute} field must be a list.",
            "lowercase": "The {attribute} field must be lowercase.",
            "lt": {
                "array": "The {attribute} field must have less than {value} items.",
                "file": "The {attribute} field must be less than {value} kilobytes.",
                "numeric": "The {attribute} field must be less than {value}.",
                "string": "The {attribute} field must be less than {value} characters."
            },
            "lte": {
                "array": "The {attribute} field must not have more than {value} items.",
                "file": "The {attribute} field must be less than or equal to {value} kilobytes.",
                "numeric": "The {attribute} field must be less than or equal to {value}.",
                "string": "The {attribute} field must be less than or equal to {value} characters."
            },
            "mac_address": "The {attribute} field must be a valid MAC address.",
            "max": {
                "array": "The {attribute} field must not have more than {max} items.",
                "file": "The {attribute} field must not be greater than {max} kilobytes.",
                "numeric": "The {attribute} field must not be greater than {max}.",
                "string": "The {attribute} field must not be greater than {max} characters."
            },
            "max_digits": "The {attribute} field must not have more than {max} digits.",
            "mimes": "The {attribute} field must be a file of type: {values}.",
            "mimetypes": "The {attribute} field must be a file of type: {values}.",
            "min": {
                "array": "The {attribute} field must have at least {min} items.",
                "file": "The {attribute} field must be at least {min} kilobytes.",
                "numeric": "The {attribute} field must be at least {min}.",
                "string": "The {attribute} field must be at least {min} characters."
            },
            "min_digits": "The {attribute} field must have at least {min} digits.",
            "missing": "The {attribute} field must be missing.",
            "missing_if": "The {attribute} field must be missing when {other} is {value}.",
            "missing_unless": "The {attribute} field must be missing unless {other} is {value}.",
            "missing_with": "The {attribute} field must be missing when {values} is present.",
            "missing_with_all": "The {attribute} field must be missing when {values} are present.",
            "multiple_of": "The {attribute} field must be a multiple of {value}.",
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} field format is invalid.",
            "numeric": "The {attribute} field must be a number.",
            "password": {
                "letters": "The {attribute} field must contain at least one letter.",
                "mixed": "The {attribute} field must contain at least one uppercase and one lowercase letter.",
                "numbers": "The {attribute} field must contain at least one number.",
                "symbols": "The {attribute} field must contain at least one symbol.",
                "uncompromised": "The given {attribute} has appeared in a data leak. Please choose a different {attribute}."
            },
            "present": "The {attribute} field must be present.",
            "present_if": "The {attribute} field must be present when {other} is {value}.",
            "present_unless": "The {attribute} field must be present unless {other} is {value}.",
            "present_with": "The {attribute} field must be present when {values} is present.",
            "present_with_all": "The {attribute} field must be present when {values} are present.",
            "prohibited": "The {attribute} field is prohibited.",
            "prohibited_if": "The {attribute} field is prohibited when {other} is {value}.",
            "prohibited_if_accepted": "The {attribute} field is prohibited when {other} is accepted.",
            "prohibited_if_declined": "The {attribute} field is prohibited when {other} is declined.",
            "prohibited_unless": "The {attribute} field is prohibited unless {other} is in {values}.",
            "prohibits": "The {attribute} field prohibits {other} from being present.",
            "regex": "The {attribute} field format is invalid.",
            "required": "The {attribute} field is required.",
            "required_array_keys": "The {attribute} field must contain entries for: {values}.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_if_accepted": "The {attribute} field is required when {other} is accepted.",
            "required_if_declined": "The {attribute} field is required when {other} is declined.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} are present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} field must match {other}.",
            "size": {
                "array": "The {attribute} field must contain {size} items.",
                "file": "The {attribute} field must be {size} kilobytes.",
                "numeric": "The {attribute} field must be {size}.",
                "string": "The {attribute} field must be {size} characters."
            },
            "starts_with": "The {attribute} field must start with one of the following: {values}.",
            "string": "The {attribute} field must be a string.",
            "timezone": "The {attribute} field must be a valid timezone.",
            "ulid": "The {attribute} field must be a valid ULID.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "uppercase": "The {attribute} field must be uppercase.",
            "url": "The {attribute} field must be a valid URL.",
            "uuid": "The {attribute} field must be a valid UUID.",
            "attributes": {
                "address": "address",
                "affiliate_url": "affiliate URL",
                "age": "age",
                "amount": "amount",
                "announcement": "announcement",
                "area": "area",
                "audience_prize": "audience prize",
                "audience_winner": "audience winner",
                "available": "available",
                "birthday": "birthday",
                "body": "body",
                "city": "city",
                "color": "color",
                "company": "company",
                "compilation": "compilation",
                "concept": "concept",
                "conditions": "conditions",
                "content": "content",
                "contest": "contest",
                "country": "country",
                "cover": "cover",
                "created_at": "created at",
                "creator": "creator",
                "currency": "currency",
                "current_password": "current password",
                "customer": "customer",
                "date": "date",
                "date_of_birth": "date of birth",
                "dates": "dates",
                "day": "day",
                "deleted_at": "deleted at",
                "description": "description",
                "display_type": "display type",
                "district": "district",
                "duration": "duration",
                "email": "email",
                "excerpt": "excerpt",
                "filter": "filter",
                "finished_at": "finished at",
                "first_name": "first name",
                "gender": "gender",
                "grand_prize": "grand prize",
                "group": "group",
                "hour": "hour",
                "image": "image",
                "image_desktop": "desktop image",
                "image_main": "main image",
                "image_mobile": "mobile image",
                "images": "images",
                "is_audience_winner": "is audience winner",
                "is_hidden": "is hidden",
                "is_subscribed": "is subscribed",
                "is_visible": "is visible",
                "is_winner": "is winner",
                "items": "items",
                "key": "key",
                "last_name": "last name",
                "lesson": "lesson",
                "line_address_1": "line address 1",
                "line_address_2": "line address 2",
                "login": "login",
                "message": "message",
                "middle_name": "middle name",
                "minute": "minute",
                "mobile": "mobile",
                "month": "month",
                "name": "name",
                "national_code": "national code",
                "number": "number",
                "password": "password",
                "password_confirmation": "password confirmation",
                "phone": "phone",
                "photo": "photo",
                "portfolio": "portfolio",
                "postal_code": "postal code",
                "preview": "preview",
                "price": "price",
                "product_id": "product ID",
                "product_uid": "product UID",
                "product_uuid": "product UUID",
                "promo_code": "promo code",
                "province": "province",
                "quantity": "quantity",
                "reason": "reason",
                "recaptcha_response_field": "recaptcha response field",
                "referee": "referee",
                "referees": "referees",
                "region": "region",
                "reject_reason": "reject reason",
                "remember": "remember",
                "restored_at": "restored at",
                "result_text_under_image": "result text under image",
                "role": "role",
                "rule": "rule",
                "rules": "rules",
                "second": "second",
                "sex": "sex",
                "shipment": "shipment",
                "short_text": "short text",
                "size": "size",
                "skills": "skills",
                "slug": "slug",
                "specialization": "specialization",
                "started_at": "started at",
                "state": "state",
                "status": "status",
                "street": "street",
                "student": "student",
                "subject": "subject",
                "tag": "tag",
                "tags": "tags",
                "teacher": "teacher",
                "terms": "terms",
                "test_description": "test description",
                "test_locale": "test locale",
                "test_name": "test name",
                "text": "text",
                "time": "time",
                "title": "title",
                "type": "type",
                "updated_at": "updated at",
                "user": "user",
                "username": "username",
                "value": "value",
                "winner": "winner",
                "work": "work",
                "year": "year"
            }
        },
        "http-statuses": {
            "0": "Unknown Error",
            "100": "Continue",
            "101": "Switching Protocols",
            "102": "Processing",
            "200": "OK",
            "201": "Created",
            "202": "Accepted",
            "203": "Non-Authoritative Information",
            "204": "No Content",
            "205": "Reset Content",
            "206": "Partial Content",
            "207": "Multi-Status",
            "208": "Already Reported",
            "226": "IM Used",
            "300": "Multiple Choices",
            "301": "Moved Permanently",
            "302": "Found",
            "303": "See Other",
            "304": "Not Modified",
            "305": "Use Proxy",
            "307": "Temporary Redirect",
            "308": "Permanent Redirect",
            "400": "Bad Request",
            "401": "Unauthorized",
            "402": "Payment Required",
            "403": "Forbidden",
            "404": "Not Found",
            "405": "Method Not Allowed",
            "406": "Not Acceptable",
            "407": "Proxy Authentication Required",
            "408": "Request Timeout",
            "409": "Conflict",
            "410": "Gone",
            "411": "Length Required",
            "412": "Precondition Failed",
            "413": "Payload Too Large",
            "414": "URI Too Long",
            "415": "Unsupported Media Type",
            "416": "Range Not Satisfiable",
            "417": "Expectation Failed",
            "418": "I'm a teapot",
            "419": "Session Has Expired",
            "421": "Misdirected Request",
            "422": "Unprocessable Entity",
            "423": "Locked",
            "424": "Failed Dependency",
            "425": "Too Early",
            "426": "Upgrade Required",
            "428": "Precondition Required",
            "429": "Too Many Requests",
            "431": "Request Header Fields Too Large",
            "444": "Connection Closed Without Response",
            "449": "Retry With",
            "451": "Unavailable For Legal Reasons",
            "499": "Client Closed Request",
            "500": "Internal Server Error",
            "501": "Not Implemented",
            "502": "Bad Gateway",
            "503": "Maintenance Mode",
            "504": "Gateway Timeout",
            "505": "HTTP Version Not Supported",
            "506": "Variant Also Negotiates",
            "507": "Insufficient Storage",
            "508": "Loop Detected",
            "509": "Bandwidth Limit Exceeded",
            "510": "Not Extended",
            "511": "Network Authentication Required",
            "520": "Unknown Error",
            "521": "Web Server is Down",
            "522": "Connection Timed Out",
            "523": "Origin Is Unreachable",
            "524": "A Timeout Occurred",
            "525": "SSL Handshake Failed",
            "526": "Invalid SSL Certificate",
            "527": "Railgun Error",
            "598": "Network Read Timeout Error",
            "599": "Network Connect Timeout Error",
            "unknownError": "Unknown Error"
        },
        "passwords": {
            "reset": "Your password has been reset.",
            "sent": "We have emailed your password reset link.",
            "throttled": "Please wait before retrying.",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that email address."
        },
        "pagination": {
            "next": "Next &raquo;",
            "previous": "&laquo; Previous"
        }
    },
    "nl": {
        "(and {count} more error)": "(en {count} andere foutmelding)",
        "(and {count} more errors)": "(en {count} andere foutmelding)|(en {count} andere foutmeldingen)|(en {count} andere foutmeldingen)",
        "404 - Page not found": "404 - Pagina niet gevonden",
        "8-12 hours": "8-12 uur",
        "{Attribute} {lang}": "{Attribute} {lang}",
        "{count} characters": "{count} characters",
        "A decryption key is required.": "Een decryptiesleutel is verplicht.",
        "A Timeout Occurred": "Time-out opgetreden",
        "About store text": "Over winkel tekst",
        "About store title": "Over winkel titel",
        "About us": "Over ons",
        "Accept": "Aanvaarden",
        "Accepted": "Aanvaard",
        "Action": "Actie",
        "Actions": "Acties",
        "Active": "Actief",
        "Active promotion": "Actieve aanbiedingen",
        "Add": "Toevoegen",
        "Add {name}": "{Name} toevoegen",
        "Address & contact": "Adres & contact",
        "Admin": "Beheerder",
        "Administrator": "Beheerder",
        "Agree": "Akkoord",
        "All rights reserved.": "Alle rechten voorbehouden.",
        "All vacancies": "Alle vacatures",
        "Already Reported": "Al gemeld",
        "Apply directly": "Solliciteer direct",
        "Apply now": "Solliciteer direct",
        "Archive": "Archiveren",
        "Assign": "Toewijzen",
        "Associate": "Associëren",
        "at Jumbo Bas Bobeldijk": "bij Jumbo Bas Bobeldijk",
        "Attach": "Koppelen",
        "Available in:": "Verkrijgbaar in: ",
        "Back to home": "Terug naar home",
        "Bad Gateway": "Slechte poort",
        "Bad Request": "Foute aanvraag",
        "Bandwidth Limit Exceeded": "Bandbreedte overschreden",
        "Banner": "Banner",
        "Birthday *": "Geboortedatum *",
        "Birthday:": "Geboortedatum",
        "Browse": "Bladeren",
        "Cancel": "Annuleren",
        "Choose": "Kiezen",
        "Choose {name}": "{Name} kiezen",
        "Choose file": "Kies bestand",
        "Choose File": "Bestand kiezen",
        "Choose Image": "Afbeelding kiezen",
        "City": "Stad",
        "Click to copy": "Klik om te kopiëren",
        "Client Closed Request": "Klant Gesloten Verzoek",
        "Close": "Sluiten",
        "Collapse": "Inklappen",
        "Collapse All": "Alles inklappen",
        "Comment": "Reageren",
        "Company name": "Naam van het bedrijf",
        "Confirm": "Bevestigen",
        "Conflict": "Conflict",
        "Connect": "Verbinden",
        "Connection Closed Without Response": "Verbinding gesloten zonder reactie",
        "Connection Timed Out": "Connectie duurt te lang",
        "Contact": "Contact",
        "Contact Cards": "Contactkaarten",
        "Content": "Inhoud",
        "Content Detail Page": "Detailpagina inhoud",
        "Content Repeater": "Content Repeater",
        "Continue": "Doorgaan",
        "Create": "Aanmaken",
        "Create {name}": "{Name} aanmaken",
        "Created": "Aangemaakt",
        "Cta": "Cta",
        "Current Actions": "Huidige acties",
        "Dear": "Beste",
        "Dear {name},": "Beste {name}",
        "Delete": "Verwijderen",
        "Delete {name}": "{Name} verwijderen",
        "Delete filters": "Filters wissen",
        "Description": "Beschrijving",
        "description": "beschrijving",
        "Detach": "Loskoppelen",
        "Details": "Informatie",
        "Different opening hours": "Afwijkende openingstijden",
        "Different openings hours": "Afwijkende openingstijden",
        "Different openingshours": "Afwijkende openingstijden",
        "Disable": "Uitschakelen",
        "Discard": "Verwerpen",
        "Discount": "Korting",
        "Discount active": "Korting actief",
        "Done": "Voltooien",
        "Down": "Omlaag",
        "Duplicate": "Dupliceren",
        "Duplicate {name}": "{Name} dupliceren",
        "E-mail": "E-mail",
        "E-mail *": "E-mail *",
        "Edit": "Bewerken",
        "Edit {name}": "{Name} bewerken",
        "Edit page": "Pagina bewerken",
        "Email": "E-mail",
        "Enable": "Inschakelen",
        "Encrypted environment file already exists.": "Versleuteld environment-bestand bestaat al.",
        "Encrypted environment file not found.": "Versleuteld environment-bestand niet gevonden.",
        "End": "Einde",
        "Enter working hours here": "Vul hier de werkuren in",
        "Environment file already exists.": "Environment-bestand bestaat al.",
        "Environment file not found.": "Environment-bestand niet gevonden.",
        "errors": "fouten",
        "Everything for the nicest shopping": "Alles voor de leukste boodschap",
        "Excerpt": "Uittreksel",
        "excerpt": "uittreksel",
        "Expand": "Uitklappen",
        "Expand All": "Alles uitklappen",
        "Expectation Failed": "Niet voldaan aan verwachting",
        "Explanation": "Uitleg",
        "Export": "Exporteren",
        "Export {name}": "{Name} exporteren",
        "external url": "external url",
        "Facebook URL": "Facebook URL",
        "Failed Dependency": "Gefaalde afhankelijkheid",
        "File": "Bestand",
        "Files": "Bestanden",
        "Fine workplace": "Fijne werkplek",
        "First name *": "Voornaam *",
        "First name:": "Voornaam:",
        "Forbidden": "Geen toegang",
        "Form": "Formulier",
        "Form Job Application": "Formulier sollicitatie",
        "Found": "Gevonden",
        "Gateway Timeout": "Gateway-time-out",
        "Go Home": "Terug naar de voorpagina",
        "Go to page {page}": "Ga naar pagina {page}",
        "Gone": "Verdwenen",
        "Google Maps URL": "Google Maps URL",
        "Google maps URL": "Google maps URL",
        "Hello": "Hallo",
        "Hello!": "Hallo!",
        "Heroes": "Lokale Helden",
        "Hide": "Verbergen",
        "Hide {name}": "{Name} verbergen",
        "Hits": "Hits",
        "Home": "Startpagina",
        "Hours": "Uur",
        "hours": "uur",
        "HTTP Version Not Supported": "HTTP-versie wordt niet ondersteund",
        "I'm a teapot": "Ik ben een theepot",
        "If enabled, and no image is uploaded, the banner from the homepage will be shown.": "Indien ingeschakeld, en er is geen afbeelding geupload, dan wordt de banner van de homepage getoond.",
        "If url filled in, link will be opend in a new tab. Leave empty if using Sub items": "If url filled in, link will be opend in a new tab. Leave empty if using Sub items",
        "If you did not create an account, no further action is required.": "Als je geen account hebt aangemaakt hoef je verder niets te doen.",
        "If you did not request a password reset, no further action is required.": "Als je geen wachtwoordherstel hebt aangevraagd, hoef je verder niets te doen.",
        "If you're having trouble clicking the \"{actionText}\" button, copy and paste the URL below\ninto your web browser:": "Als je problemen hebt met de \"{actionText}\" knop, kopieer en plak de URL hieronder\nin je webbrowser:",
        "If you're having trouble clicking the \"{actionText}\" button, copy and paste the URL belowninto your web browser:": "Als je problemen hebt met de \"{actionText}\" knop, kopieer en plak de URL hierondernin je webbrowser:",
        "IM Used": "Ik ben gebruikt",
        "Image": "Afbeelding",
        "image-left": "Afbeelding links",
        "image-right": "Afbeelding rechts",
        "Impersonate": "Voordoen als een ander",
        "Impersonation": "Imitatie",
        "Import": "Importeren",
        "Import {name}": "{Name} importeren",
        "Index Page": "Indexpagina",
        "Instagram URL": "Instagram URL",
        "Insufficient Storage": "Onvoldoende opslag",
        "Internal Server Error": "Interne serverfout",
        "Intro Block": "Intro Blok",
        "Introduction": "Introductie",
        "Invalid filename.": "Ongeldige bestandsnaam.",
        "Invalid JSON was returned from the route.": "Er is ongeldige JSON teruggekomen van de route.",
        "Invalid SSL Certificate": "Ongeldig SSL-certificaat",
        "Invitation sent": "Invitation sent",
        "It is recommended to keep the {attribute} between {min} and {max} characters long": "Het wordt aanbevolen het {attribuut} tussen {min} en {max} tekens lang te houden.",
        "Kind regards,": "Met vriendelijke groet,",
        "Last name *": "Achternaam *",
        "Last name:": "Achternaam:",
        "Leave empty for no end date": "Leeg laten voor geen einddatum",
        "Leave empty to use parent details": "Leeg laten om hoofdgegevens te gebruiken",
        "length": "lengte",
        "Length Required": "Lengte vereist",
        "Like": "Leuk vinden",
        "LinkedIn URL": "LinkedIn URL",
        "Load": "Laden",
        "Local assortment": "Lokaal assortiment",
        "Local heroes": "Lokale helden",
        "local heroes": "lokale helden",
        "Localize": "Lokaliseren",
        "Location": "Locatie",
        "Locked": "Afgesloten",
        "Log In": "Inloggen",
        "Log Out": "Uitloggen",
        "Login": "Inloggen",
        "Logout": "Uitloggen",
        "Loop Detected": "Loop gedetecteerd",
        "Made by:": "Gerealiseerd door:",
        "Maintenance Mode": "Dienst niet beschikbaar",
        "marker icon": "markeringspictogram",
        "Method Not Allowed": "Methode niet toegestaan",
        "Misdirected Request": "Verkeerd geadresseerd verzoek",
        "Motivation *": "Motivatie *",
        "Moved Permanently": "Definitief verplaatst",
        "Multi-Status": "Meerdere statussen",
        "Multiple Choices": "Meerkeuze",
        "Name": "Naam",
        "name": "naam",
        "Name *": "Naam *",
        "Network Authentication Required": "Netwerkauthenticatie vereist",
        "Network Connect Timeout Error": "Fout bij time-out netwerkverbinding",
        "Network Read Timeout Error": "Time-outfout netwerk lezen",
        "New": "Nieuwe",
        "New {name}": "Nieuwe {name}",
        "New application from": "Nieuwe sollicitatie van ",
        "New URL": "Nieuwe URL",
        "News overview": "Nieuwsoverzicht",
        "No": "Nee",
        "No Content": "Geen inhoud",
        "Non-Authoritative Information": "Niet-gemachtigde informatie",
        "Not Acceptable": "Niet aanvaardbaar",
        "Not Extended": "Niet verlengd",
        "Not Found": "Niet gevonden",
        "Not Implemented": "Niet geïmplementeerd",
        "Not Modified": "Niet gewijzigd",
        "Now in our stores": "Nu in onze winkels",
        "of": "van",
        "OK": "OK",
        "Old URL": "Oude URL",
        "Open": "Openen",
        "Open in a current window": "Openen in huidig venster",
        "Open in a new window": "Openen in nieuw venster",
        "Open in a parent frame": "Openen in bovenliggend frame",
        "Open in the topmost frame": "Openen in bovenste frame",
        "Open on the website": "Openen op de website",
        "Openings hours": "Openingstijden",
        "Openingshours": "Openingstijden",
        "Order": "Bestel",
        "Origin Is Unreachable": "Herkomst is onbereikbaar",
        "Other local heroes": "Andere lokale helden",
        "Our": "Onze",
        "Our Stores": "Onze winkels",
        "Page Expired": "Pagina niet meer geldig",
        "Pagination Navigation": "Paginanavigatie",
        "Parent category": "Hoofdcategorie",
        "Partial Content": "Gedeeltelijke inhoud",
        "Payload Too Large": "Aanvraag te groot",
        "Payment Required": "Betaling vereist",
        "Permanent": "Permanent",
        "Permanent Redirect": "Definitieve omleiding",
        "Phone": "Telefoon",
        "Phone *": "Telefoon *",
        "Phone:": "Telefoon:",
        "Place": "Woonplaats",
        "Please click the button below to verify your email address.": "Klik op de knop hieronder om je e-mailadres te verifiëren.",
        "Postal code": "Postcode",
        "Precondition Failed": "Niet voldaan aan de vooraf gestelde voorwaarde",
        "Precondition Required": "Voorwaarde nodig",
        "Preview": "Voorvertoning",
        "Price": "Prijs",
        "Privacy declaration": "Privacyverklaring",
        "Processing": "Verwerken",
        "Promotion image, will be show if article is visible on homepage, image placed on the right side of the card.": "Promotie afbeelding, wordt getoond als artikel zichtbaar is op homepage, afbeelding geplaatst aan de rechterkant van de kaart.",
        "Proxy Authentication Required": "Authenticatie op de proxyserver verplicht",
        "Railgun Error": "Railgun foutmelding",
        "Range Not Satisfiable": "Bereik niet bevredigend",
        "Record": "Opnemen",
        "Regards": "Met vriendelijke groet",
        "Regards,": "Met vriendelijke groet,",
        "Register": "Registreren",
        "Request Header Fields Too Large": "Headers van de aanvraag te lang",
        "Request Timeout": "Aanvraagtijd verstreken",
        "Resend Invitation": "Resend Invitation",
        "Reset Content": "Inhoud opnieuw instellen",
        "Reset Password": "Wachtwoord herstellen",
        "Reset Password Notification": "Notificatie wachtwoordherstel",
        "Reset your password": "Je wachtwoord herstellen",
        "Restore": "Herstellen",
        "Restore {name}": "{Name} herstellen",
        "results": "resultaten",
        "Retry With": "Opnieuw proberen met",
        "Sales": "Aanbiedingen",
        "Save": "Opslaan",
        "Save & Close": "Opslaan en sluiten",
        "Save & Return": "Opslaan en teruggaan",
        "Save {name}": "{Name} opslaan",
        "Search": "Zoeken",
        "Search {name}": "{Name} zoeken",
        "See all heroes": "Bekijk alle helden",
        "See all news": "Bekijk alle nieuws",
        "See Other": "Zie andere",
        "Select": "Selecteren",
        "Select All": "Alles selecteren",
        "Send": "Versturen",
        "Send application": "Sollicitatie versturen",
        "Send email": "E-mail versturen",
        "SEO title": "SEO titel",
        "Server Error": "Serverfout",
        "Service Unavailable": "Website onbeschikbaar",
        "Services": "Diensten",
        "Session Has Expired": "Pagina verlopen",
        "Settings": "Instellingen",
        "Show": "Tonen",
        "Show {name}": "{Name} tonen",
        "Show All": "Alles tonen",
        "Show this article on the homepage as current promotion": "Laat dit artikel zien op de homepagina als huidige actie",
        "Showing": "Toont",
        "Sign In": "Aanmelden",
        "Slug": "Permalink",
        "Social media": "Sociale media",
        "Solve": "Oplossen",
        "Special Openings hours": "Afwijkende openingstijden",
        "SSL Handshake Failed": "SSL-handshake mislukt",
        "Start": "Starten",
        "Stay tuned for fun news, giveaways, offers and more!": "Blijf kijken voor leuke nieuwtjes, giveaways, aanbiedingen en meer!",
        "Stop": "Stoppen",
        "Store detail overview": "Winkel detailoverzicht",
        "Store image": "Winkel afbeelding",
        "Store name": "Naam winkel",
        "Stores Compact": "Winkels Compact",
        "Street": "Straat",
        "Street name": "Straatnaam",
        "Submit": "Indienen",
        "Subscribe": "Aanmelden",
        "Switch": "Wisselen",
        "Switch To Role": "Wisselen naar rol",
        "Switching Protocols": "Protocolwissel",
        "Tag": "Label",
        "Tags": "Labels",
        "Temporary Redirect": "Tijdelijke omleiding",
        "Terms and Conditions": "Algemene Voorwaarden",
        "Text": "Tekst",
        "text": "tekst",
        "Text left, image right": "Tekst links, afbeelding rechts",
        "Text right, image left": "Tekst rechts, afbeelding links",
        "Thank you for your application!": "Bedankt voor je sollicitatie!",
        "Thank you for your application. We will contact you shortly.": "Bedankt voor je sollicitatie. Wij zullen binnenkort contact met je opnemen.",
        "The {attribute} must contain at least one letter.": "Het {attribute} moet minimaal één letter bevatten.",
        "The {attribute} must contain at least one number.": "Het {attribute} moet minimaal één cijfer bevatten.",
        "The {attribute} must contain at least one symbol.": "Het {attribute} moet minimaal één symbool bevatten.",
        "The {attribute} must contain at least one uppercase and one lowercase letter.": "Het {attribute} moet minimaal één hoofdletter en één kleine letter bevatten.",
        "The given {attribute} has appeared in a data leak. Please choose a different {attribute}.": "Het {attribute} is aangetroffen in een datalek. Geef een ander {attribute}.",
        "The given data was invalid.": "De gegeven data was ongeldig.",
        "The response is not a streamed response.": "De respons is niet gestreamd.",
        "The response is not a view.": "De respons is geen view.",
        "The vacancyform has been filled in. See all details below.": "Het vacatureformulier is ingevuld. Bekijk alle details hieronder.",
        "This action is unauthorized.": "Deze actie is niet toegestaan.",
        "This link expires in {number} hours": "Deze link verloopt over {number} uur",
        "This page does not exist": "Deze pagina bestaat niet",
        "This password reset link will expire in {count} minutes.": "Deze link om je wachtwoord te herstellen verloopt over {count} minuten.",
        "Title": "Titel",
        "title": "titel",
        "Title different opening hours": "Titel afwijkende openingstijden",
        "Title Special Openings hours": "Titel afwijkende openingstijden",
        "to": "tot",
        "Toggle navigation": "Schakel navigatie",
        "Too Early": "Te vroeg",
        "Too Many Requests": "Te veel serververzoeken",
        "Translate": "Vertalen",
        "Translate It": "Vertalen",
        "Type": "Type",
        "Unauthorized": "Onbevoegd",
        "Unavailable For Legal Reasons": "Toegang geweigerd om juridische redenen",
        "Unknown Error": "Onbekende foutmelding",
        "Unpack": "Uitpakken",
        "Unprocessable Entity": "Aanvraag kan niet worden verwerkt",
        "Unsubscribe": "Uitschrijven",
        "Unsupported Media Type": "Media-type niet ondersteund",
        "Up": "Omhoog",
        "Update": "Aanpassen",
        "Update {name}": "{Name} bijwerken",
        "Upgrade Required": "Upgrade nodig",
        "Upload C.V": "Upload C.V",
        "Upload C.V *": "Upload C.V *",
        "Upload Motivation": "Motivatie uploaden",
        "Upload Motivation *": "Motivatie uploaden *",
        "URI Too Long": "Aanvraag-URL te lang",
        "url": "url",
        "Use Proxy": "Gebruik Proxy",
        "User": "Gebruiker",
        "Users": "Gebruikers",
        "Vacancies": "Vacatures",
        "vacancies": "vacatures",
        "Vacancies Recent": "Recente vacatures",
        "Vacancy": "Vacature",
        "vacancy": "vacature",
        "Vacancy Overview": "Overzicht vacatures",
        "Vacancyfilters": "Vacaturefilters",
        "Variant Also Negotiates": "Variant onderhandelt ook",
        "Variants": "Varianten",
        "Verify Email Address": "Verifieer e-mailadres",
        "Verify your email address": "Verify your email address",
        "View": "Bekijken",
        "View {name}": "{Name} bekijken",
        "We are running some maintenance, we will be back in a few minutes.": "We are running some maintenance, we will be back in a few minutes.",
        "We have done our best, but it seems that the page you requested does not exist (anymore) or that it may have moved.": "We hebben ons best gedaan, maar het lijkt erop dat de door u opgevraagde pagina niet (meer) bestaat of dat deze is verplaatst.",
        "We have done our best, but it seems that the page you requested does not exist (anymore) or that it may have moved. Of course you can always go to the homepage, one of our departments or view one of our projects, for example.": "We hebben ons best gedaan, maar het lijkt erop dat de door u opgevraagde pagina niet (meer) bestaat of dat deze verplaatst is. U kunt natuurlijk altijd naar de homepage, een van onze afdelingen of bijvoorbeeld een van onze projecten gaan.",
        "Web Server is Down": "Webserver is onbereikbaar",
        "Webshop vers bereide producten": "Webshop vers bereide producten",
        "Website": "Website",
        "What kind of work are you looking for?": "Wat voor werk zoek je?",
        "When enabled, an email will be sent to the user, letting them know their account has been created.": "When enabled, an email will be sent to the user, letting them know their account has been created.",
        "Which store do you want to work at?": "Bij welke winkel wil je werken?",
        "Whoops!": "Oeps!",
        "Yes": "Ja",
        "You are receiving this email because we received a password reset request for your account.": "Je ontvangt deze e-mail omdat we een wachtwoordherstel verzoek hebben ontvangen voor je account.",
        "You will receive this email because your account is ready for {siteName}": "Je ontvangt deze e-mail omdat je account klaar is voor {siteName}",
        "Your account for {siteName}": "Je account voor {siteName}",
        "Your message has been sent successfully!": "Uw bericht is succesvol verzonden!",
        "auth": {
            "failed": "Deze combinatie van e-mailadres en wachtwoord is niet geldig.",
            "password": "Wachtwoord is onjuist.",
            "throttle": "Te veel mislukte aanmeldpogingen. Probeer het nog eens over {seconds} seconden."
        },
        "actions": {
            "accept": "Aanvaarden",
            "action": "Actie",
            "actions": "Acties",
            "add": "Toevoegen",
            "admin": "Beheerder",
            "agree": "Akkoord",
            "archive": "Archiveren",
            "assign": "Toewijzen",
            "associate": "Associëren",
            "attach": "Bijvoegen",
            "browse": "Bladeren",
            "cancel": "Annuleren",
            "choose": "Kiezen",
            "choose_file": "Bestand kiezen",
            "choose_image": "Afbeelding kiezen",
            "click_to_copy": "Klik om te kopiëren",
            "close": "Sluiten",
            "collapse": "Inklappen",
            "collapse_all": "Alles inklappen",
            "comment": "Reageren",
            "confirm": "Bevestigen",
            "connect": "Verbinden",
            "create": "Aanmaken",
            "delete": "Verwijderen",
            "detach": "Loskoppelen",
            "details": "Details",
            "disable": "Uitschakelen",
            "discard": "Verwerpen",
            "done": "Voltooien",
            "down": "Omlaag",
            "duplicate": "Dupliceren",
            "edit": "Bewerken",
            "enable": "Inschakelen",
            "expand": "Uitklappen",
            "expand_all": "Alles uitklappen",
            "explanation": "Uitleg",
            "export": "Exporteren",
            "file": "Bestand",
            "files": "Bestanden",
            "go_home": "Naar startpagina",
            "hide": "Verbergen",
            "home": "Startpagina",
            "image": "Afbeelding",
            "impersonate": "Imiteren",
            "impersonation": "Imitatie",
            "import": "Importeren",
            "introduction": "Introductie",
            "like": "Leuk vinden",
            "load": "Laden",
            "localize": "Lokaliseren",
            "log_in": "Inloggen",
            "log_out": "Uitloggen",
            "named": {
                "add": "{Name} toevoegen",
                "choose": "{Name} kiezen",
                "create": "{Name} aanmaken",
                "delete": "{Name} verwijderen",
                "duplicate": "{Name} dupliceren",
                "edit": "{Name} bewerken",
                "export": "{Name} exporteren",
                "hide": "{Name} verbergen",
                "import": "{Name} importeren",
                "new": "Nieuwe {name}",
                "restore": "{Name} herstellen",
                "save": "{Name} opslaan",
                "search": "{Name} zoeken",
                "show": "{Name} tonen",
                "update": "{Name} bijwerken",
                "view": "{Name} bekijken"
            },
            "new": "Nieuw",
            "no": "Nee",
            "open": "Openen",
            "open_website": "Website openen",
            "preview": "Voorbeeld",
            "price": "Prijs",
            "record": "Opnemen",
            "restore": "Herstellen",
            "save": "Opslaan",
            "save_and_close": "Opslaan en sluiten",
            "save_and_return": "Opslaan en teruggaan",
            "search": "Zoeken",
            "select": "Selecteren",
            "select_all": "Alles selecteren",
            "send": "Versturen",
            "settings": "Instellingen",
            "show": "Tonen",
            "show_all": "Alles tonen",
            "sign_in": "Aanmelden",
            "solve": "Oplossen",
            "start": "Starten",
            "stop": "Stoppen",
            "submit": "Indienen",
            "subscribe": "Abonneren",
            "switch": "Wisselen",
            "switch_to_role": "Wisselen naar rol",
            "tag": "Label",
            "tags": "Labels",
            "target_link": {
                "blank": "Openen in nieuw venster",
                "parent": "Openen in bovenliggend frame",
                "self": "Openen in huidig venster",
                "top": "Openen in bovenste frame"
            },
            "translate": "Vertalen",
            "translate_it": "Vertalen",
            "unpack": "Uitpakken",
            "unsubscribe": "Uitschrijven",
            "up": "Omhoog",
            "update": "Bijwerken",
            "user": "Gebruiker",
            "view": "Bekijken",
            "yes": "Ja"
        },
        "validation": {
            "accepted": "{Attribute} moet worden geaccepteerd.",
            "accepted_if": "{Attribute} moet worden geaccepteerd als {other} {value} is.",
            "active_url": "{Attribute} is geen geldige URL.",
            "after": "{Attribute} moet een datum na {date} zijn.",
            "after_or_equal": "{Attribute} moet een datum na of gelijk aan {date} zijn.",
            "alpha": "{Attribute} mag alleen letters bevatten.",
            "alpha_dash": "{Attribute} mag alleen letters, nummers, underscores (_) en streepjes (-) bevatten.",
            "alpha_num": "{Attribute} mag alleen letters en nummers bevatten.",
            "any_of": "Het veld {attribute} is ongeldig.",
            "array": "{Attribute} moet geselecteerde elementen bevatten.",
            "ascii": "De {attribute} mag alleen alfanumerieke tekens en symbolen van één byte bevatten.",
            "before": "{Attribute} moet een datum vóór {date} zijn.",
            "before_or_equal": "{Attribute} moet een datum vóór of gelijk aan {date} zijn.",
            "between": {
                "array": "{Attribute} moet tussen {min} en {max} waardes bevatten.",
                "file": "{Attribute} moet tussen {min} en {max} kilobytes zijn.",
                "numeric": "{Attribute} moet tussen {min} en {max} zijn.",
                "string": "{Attribute} moet tussen {min} en {max} karakters zijn."
            },
            "boolean": "{Attribute} moet ja of nee zijn.",
            "can": "{Attribute} bevat een waarde waar je niet bevoegd voor bent.",
            "confirmed": "Bevestiging van {attribute} komt niet overeen.",
            "contains": "{Attribute} mist een vereiste waarde.",
            "current_password": "Huidig wachtwoord is onjuist.",
            "date": "{Attribute} moet een datum bevatten.",
            "date_equals": "{Attribute} moet een datum gelijk aan {date} zijn.",
            "date_format": "{Attribute} voldoet niet aan het formaat {format}.",
            "decimal": "De {attribute} moet {decimal} decimalen hebben.",
            "declined": "{Attribute} moet afgewezen worden.",
            "declined_if": "{Attribute} moet afgewezen worden wanneer {other} gelijk is aan {value}.",
            "different": "{Attribute} en {other} moeten verschillend zijn.",
            "digits": "{Attribute} moet bestaan uit {digits} cijfers.",
            "digits_between": "{Attribute} moet bestaan uit minimaal {min} en maximaal {max} cijfers.",
            "dimensions": "{Attribute} heeft geen geldige afmetingen.",
            "distinct": "{Attribute} heeft een dubbele waarde.",
            "doesnt_contain": "Het veld {attribute} mag geen van de volgende bevatten: {values}.",
            "doesnt_end_with": "{Attribute} mag niet eindigen met één van de volgende waarden: {values}.",
            "doesnt_start_with": "{Attribute} mag niet beginnen met één van de volgende waarden: {values}.",
            "email": "{Attribute} is geen geldig e-mailadres.",
            "encoding": "{Attribute} moet gecodeerd zijn in {encoding}.",
            "ends_with": "{Attribute} moet met één van de volgende waarden eindigen: {values}.",
            "enum": "Gekozen {attribute} is ongeldig.",
            "exists": "{Attribute} bestaat niet.",
            "extensions": "{Attribute} moet een van de volgende bestandsextensies hebben: {values}.",
            "file": "{Attribute} moet een bestand zijn.",
            "filled": "{Attribute} is verplicht.",
            "gt": {
                "array": "{Attribute} moet meer dan {value} waardes bevatten.",
                "file": "{Attribute} moet groter zijn dan {value} kilobytes.",
                "numeric": "{Attribute} moet groter zijn dan {value}.",
                "string": "{Attribute} moet meer dan {value} tekens bevatten."
            },
            "gte": {
                "array": "{Attribute} moet {value} of meer waardes bevatten.",
                "file": "{Attribute} moet groter of gelijk zijn aan {value} kilobytes.",
                "numeric": "{Attribute} moet groter of gelijk zijn aan {value}.",
                "string": "{Attribute} moet minimaal {value} tekens bevatten."
            },
            "hex_color": "{Attribute} moet een geldige hexadecimale kleurcode zijn.",
            "image": "{Attribute} moet een afbeelding zijn.",
            "in": "{Attribute} is ongeldig.",
            "in_array": "{Attribute} bestaat niet in {other}.",
            "in_array_keys": "Het veld {attribute} moet minstens één van de volgende sleutels bevatten: {values}.",
            "integer": "{Attribute} moet een getal zijn.",
            "ip": "{Attribute} moet een geldig IP-adres zijn.",
            "ipv4": "{Attribute} moet een geldig IPv4-adres zijn.",
            "ipv6": "{Attribute} moet een geldig IPv6-adres zijn.",
            "json": "{Attribute} moet een geldige JSON-string zijn.",
            "list": "Het veld {attribute} moet een lijst zijn.",
            "lowercase": "{Attribute} mag alleen kleine letters bevatten.",
            "lt": {
                "array": "{Attribute} moet minder dan {value} waardes bevatten.",
                "file": "{Attribute} moet kleiner zijn dan {value} kilobytes.",
                "numeric": "{Attribute} moet kleiner zijn dan {value}.",
                "string": "{Attribute} moet minder dan {value} tekens bevatten."
            },
            "lte": {
                "array": "{Attribute} moet {value} of minder waardes bevatten.",
                "file": "{Attribute} moet kleiner of gelijk zijn aan {value} kilobytes.",
                "numeric": "{Attribute} moet kleiner of gelijk zijn aan {value}.",
                "string": "{Attribute} moet maximaal {value} tekens bevatten."
            },
            "mac_address": "{Attribute} moet een geldig MAC-adres zijn.",
            "max": {
                "array": "{Attribute} mag niet meer dan {max} waardes bevatten.",
                "file": "{Attribute} mag niet meer dan {max} kilobytes zijn.",
                "numeric": "{Attribute} mag niet hoger dan {max} zijn.",
                "string": "{Attribute} mag niet uit meer dan {max} tekens bestaan."
            },
            "max_digits": "{Attribute} mag niet uit meer dan {max} cijfers bestaan.",
            "mimes": "{Attribute} moet een bestand zijn van het bestandstype {values}.",
            "mimetypes": "{Attribute} moet een bestand zijn van het bestandstype {values}.",
            "min": {
                "array": "{Attribute} moet minimaal {min} waardes bevatten.",
                "file": "{Attribute} moet minimaal {min} kilobytes zijn.",
                "numeric": "{Attribute} moet minimaal {min} zijn.",
                "string": "{Attribute} moet minimaal {min} tekens zijn."
            },
            "min_digits": "{Attribute} moet minimaal uit {min} cijfers bestaan.",
            "missing": "Het veld {attribute} moet ontbreken.",
            "missing_if": "Het veld {attribute} moet ontbreken als {other} {value} is.",
            "missing_unless": "Het veld {attribute} moet ontbreken, tenzij {other} {value} is.",
            "missing_with": "Het veld {attribute} moet ontbreken wanneer {values} aanwezig is.",
            "missing_with_all": "Het veld {attribute} moet ontbreken wanneer er {values} aanwezig zijn.",
            "multiple_of": "{Attribute} moet een veelvoud van {value} zijn.",
            "not_in": "{Attribute} is ongeldig.",
            "not_regex": "Het formaat van {attribute} is ongeldig.",
            "numeric": "{Attribute} moet een getal zijn.",
            "password": {
                "letters": "{Attribute} moet minimaal één letter bevatten.",
                "mixed": "{Attribute} moet minimaal één kleine letter en één hoofdletter bevatten.",
                "numbers": "{Attribute} moet minimaal één cijfer bevatten.",
                "symbols": "{Attribute} moet minimaal één vreemd teken bevatten.",
                "uncompromised": "Het opgegeven {attribute} komt voor in een datalek. Kies een ander {attribute}."
            },
            "present": "{Attribute} moet aanwezig zijn.",
            "present_if": "{Attribute} moet aanwezig zijn als {other} {value} is.",
            "present_unless": "{Attribute} moet aanwezig zijn tenzij {other} {value} is.",
            "present_with": "{Attribute} moet aanwezig zijn als {values} aanwezig is.",
            "present_with_all": "{Attribute} moet aanwezig zijn als {values} aanwezig zijn.",
            "prohibited": "{Attribute} is niet toegestaan.",
            "prohibited_if": "{Attribute} is niet toegestaan indien {other} gelijk is aan {value}.",
            "prohibited_if_accepted": "Het veld {attribute} is niet toegestaan wanneer {other} is geaccepteerd.",
            "prohibited_if_declined": "Het veld {attribute} is niet toegestaan wanneer {other} is afgewezen.",
            "prohibited_unless": "{Attribute} is niet toegestaan tenzij {other} gelijk is aan {values}.",
            "prohibits": "{Attribute} is niet toegestaan in combinatie met {other}.",
            "regex": "Het formaat van {attribute} is ongeldig.",
            "required": "{Attribute} is verplicht.",
            "required_array_keys": "{Attribute} moet waardes bevatten voor {values}.",
            "required_if": "{Attribute} is verplicht indien {other} gelijk is aan {value}.",
            "required_if_accepted": "{Attribute} is verplicht indien {other} is geaccepteerd.",
            "required_if_declined": "{Attribute} is verplicht indien {other} is geweigerd.",
            "required_unless": "{Attribute} is verplicht tenzij {other} gelijk is aan {values}.",
            "required_with": "{Attribute} is verplicht in combinatie met {values}.",
            "required_with_all": "{Attribute} is verplicht in combinatie met {values}.",
            "required_without": "{Attribute} is verplicht als {values} niet ingevuld is.",
            "required_without_all": "{Attribute} is verplicht als {values} niet ingevuld zijn.",
            "same": "{Attribute} en {other} moeten overeenkomen.",
            "size": {
                "array": "{Attribute} moet {size} waardes bevatten.",
                "file": "{Attribute} moet {size} kilobytes groot zijn.",
                "numeric": "{Attribute} moet {size} zijn.",
                "string": "{Attribute} moet {size} tekens zijn."
            },
            "starts_with": "{Attribute} moet beginnen met een van de volgende: {values}.",
            "string": "{Attribute} moet een tekst zijn.",
            "timezone": "{Attribute} moet een geldige tijdzone zijn.",
            "ulid": "De {attribute} moet een geldige ULID zijn.",
            "unique": "{Attribute} is al in gebruik.",
            "uploaded": "Het uploaden van {attribute} is mislukt.",
            "uppercase": "{Attribute} mag alleen hoofdletters bevatten.",
            "url": "{Attribute} moet een geldige URL zijn.",
            "uuid": "{Attribute} moet een geldige UUID zijn.",
            "attributes": {
                "address": "adres",
                "affiliate_url": "partner-URL",
                "age": "leeftijd",
                "amount": "bedrag",
                "announcement": "aankondiging",
                "area": "gebied",
                "audience_prize": "publieksprijs",
                "audience_winner": "publiekswinnaar",
                "available": "beschikbaar",
                "birthday": "verjaardag",
                "body": "inhoud",
                "city": "stad",
                "color": "kleur",
                "company": "bedrijf",
                "compilation": "compilatie",
                "concept": "concept",
                "conditions": "voorwaarden",
                "content": "inhoud",
                "contest": "wedstrijd",
                "country": "land",
                "cover": "omslag",
                "created_at": "aangemaakt op",
                "creator": "maker",
                "currency": "valuta",
                "current_password": "huidig wachtwoord",
                "customer": "klant",
                "date": "datum",
                "date_of_birth": "geboortedatum",
                "dates": "datums",
                "day": "dag",
                "deleted_at": "verwijderd op",
                "description": "omschrijving",
                "display_type": "weergavetype",
                "district": "wijk",
                "duration": "tijdsduur",
                "email": "e-mailadres",
                "excerpt": "uittreksel",
                "filter": "filter",
                "finished_at": "klaar om",
                "first_name": "voornaam",
                "gender": "geslacht",
                "grand_prize": "grote prijs",
                "group": "groep",
                "hour": "uur",
                "image": "afbeelding",
                "image_desktop": "bureaubladafbeelding",
                "image_main": "hoofdafbeelding",
                "image_mobile": "mobiele afbeelding",
                "images": "afbeeldingen",
                "is_audience_winner": "is publiekswinnaar",
                "is_hidden": "is verborgen",
                "is_subscribed": "is geabonneerd",
                "is_visible": "is zichtbaar",
                "is_winner": "is winnaar",
                "items": "artikels",
                "key": "sleutel",
                "last_name": "achternaam",
                "lesson": "les",
                "line_address_1": "adresregel 1",
                "line_address_2": "adresregel 2",
                "login": "login",
                "message": "bericht",
                "middle_name": "tweede naam",
                "minute": "minuut",
                "mobile": "mobiel",
                "month": "maand",
                "name": "naam",
                "national_code": "landcode",
                "number": "nummer",
                "password": "wachtwoord",
                "password_confirmation": "wachtwoordbevestiging",
                "phone": "telefoonnummer",
                "photo": "foto",
                "portfolio": "portfolio",
                "postal_code": "postcode",
                "preview": "voorbeeld",
                "price": "prijs",
                "product_id": "product-ID",
                "product_uid": "product-UID",
                "product_uuid": "product-UUID",
                "promo_code": "promo-code",
                "province": "provincie",
                "quantity": "hoeveelheid",
                "reason": "reden",
                "recaptcha_response_field": "recaptcha-antwoordveld",
                "referee": "scheidsrechter",
                "referees": "scheidsrechters",
                "region": "regio",
                "reject_reason": "afwijsreden",
                "remember": "onthouden",
                "restored_at": "hersteld op",
                "result_text_under_image": "antwoord tekst onder afbeelding",
                "role": "rol",
                "rule": "regel",
                "rules": "regels",
                "second": "seconde",
                "sex": "geslacht",
                "shipment": "verzending",
                "short_text": "korte tekst",
                "size": "grootte",
                "skills": "vaardigheden",
                "slug": "slug",
                "specialization": "specialisatie",
                "started_at": "gestart op",
                "state": "staat",
                "status": "status",
                "street": "straat",
                "student": "leerling",
                "subject": "onderwerp",
                "tag": "label",
                "tags": "labels",
                "teacher": "docent",
                "terms": "voorwaarden",
                "test_description": "testomschrijving",
                "test_locale": "testlandinstelling",
                "test_name": "testnaam",
                "text": "tekst",
                "time": "tijd",
                "title": "titel",
                "type": "type",
                "updated_at": "bijgewerkt op",
                "user": "gebruiker",
                "username": "gebruikersnaam",
                "value": "waarde",
                "winner": "winnaar",
                "work": "werk",
                "year": "jaar"
            }
        },
        "http-statuses": {
            "0": "Onbekende foutmelding",
            "100": "Doorgaan",
            "101": "Protocolwissel",
            "102": "Verwerken",
            "200": "Oké",
            "201": "Aangemaakt",
            "202": "Aanvaard",
            "203": "Niet-gemachtigde informatie",
            "204": "Geen inhoud",
            "205": "Inhoud opnieuw instellen",
            "206": "Gedeeltelijke inhoud",
            "207": "Meerdere statussen",
            "208": "Al gemeld",
            "226": "Ik ben gebruikt",
            "300": "Meerkeuze",
            "301": "Definitief verplaatst",
            "302": "Gevonden",
            "303": "Zie andere",
            "304": "Niet gewijzigd",
            "305": "Gebruik Proxy",
            "307": "Tijdelijke omleiding",
            "308": "Definitieve omleiding",
            "400": "Foute aanvraag",
            "401": "Niet geautoriseerd",
            "402": "Betaalde toegang",
            "403": "Verboden toegang",
            "404": "Niet gevonden",
            "405": "Methode niet toegestaan",
            "406": "Niet aanvaardbaar",
            "407": "Authenticatie op de proxyserver verplicht",
            "408": "Aanvraagtijd verstreken",
            "409": "Conflict",
            "410": "Verdwenen",
            "411": "Lengte vereist",
            "412": "Niet voldaan aan de vooraf gestelde voorwaarde",
            "413": "Aanvraag te groot",
            "414": "Aanvraag-URL te lang",
            "415": "Media-type niet ondersteund",
            "416": "Bereik niet bevredigend",
            "417": "Niet voldaan aan verwachting",
            "418": "Ik ben een theepot",
            "419": "Pagina verlopen",
            "421": "Verkeerd geadresseerd verzoek",
            "422": "Aanvraag kan niet worden verwerkt",
            "423": "Afgesloten",
            "424": "Gefaalde afhankelijkheid",
            "425": "Te vroeg",
            "426": "Upgrade nodig",
            "428": "Voorwaarde nodig",
            "429": "Te veel requests",
            "431": "Headers van de aanvraag te lang",
            "444": "Verbinding gesloten zonder reactie",
            "449": "Opnieuw proberen met",
            "451": "Toegang geweigerd om juridische redenen",
            "499": "Klant Gesloten Verzoek",
            "500": "Interne serverfout",
            "501": "Niet geïmplementeerd",
            "502": "Slechte poort",
            "503": "Dienst niet beschikbaar",
            "504": "Gateway-time-out",
            "505": "HTTP-versie wordt niet ondersteund",
            "506": "Variant onderhandelt ook",
            "507": "Onvoldoende opslag",
            "508": "Loop gedetecteerd",
            "509": "Bandbreedte overschreden",
            "510": "Niet verlengd",
            "511": "Netwerkauthenticatie vereist",
            "520": "Onbekende foutmelding",
            "521": "Webserver is onbereikbaar",
            "522": "Connectie duurt te lang",
            "523": "Herkomst is onbereikbaar",
            "524": "Time-out opgetreden",
            "525": "SSL-handshake mislukt",
            "526": "Ongeldig SSL-certificaat",
            "527": "Railgun foutmelding",
            "598": "Time-outfout netwerk lezen",
            "599": "Fout bij time-out netwerkverbinding",
            "unknownError": "Onbekende foutmelding"
        },
        "routes": {
            "news": "nieuws",
            "local-heroes": "lokale-helden",
            "vacancies": "vacatures",
            "stores": "winkels"
        },
        "passwords": {
            "reset": "Het wachtwoord van uw account is gewijzigd.",
            "sent": "We hebben een e-mail verstuurd met instructies om een nieuw wachtwoord in te stellen.",
            "throttled": "Gelieve even te wachten en het dan opnieuw te proberen.",
            "token": "Dit wachtwoordhersteltoken is niet geldig.",
            "user": "Geen gebruiker bekend met dit e-mailadres."
        },
        "pagination": {
            "next": "Volgende &raquo;",
            "previous": "&laquo; Vorige"
        }
    }
}
